/* vendor-feed-slider.js
 * Fills the same-vendor carousel (snippets/vendor-feed.liquid) with products from the
 * same (hidden) vendor, fetched via /search?q=vendor:"X"&view=vendorfeed.
 * Extends card-product-slider: excludes the current product, keeps a single carousel per
 * page (the copy rendered inside featured-products wins), and stays hidden (CSS) if empty.
 */
(function () {
  function define() {
    var Base = customElements.get('card-product-slider');
    if (!Base) {
      customElements.whenDefined('card-product-slider').then(define);
      return;
    }
    if (customElements.get('vendor-feed-slider')) return;

    class VendorFeedSlider extends Base {
      fetchItems() {
        var url = this.getAttribute('data-url');
        if (!url) return;
        // One same-vendor carousel per page: the copy rendered inside the
        // featured-products section wins, the standalone one stands down.
        var variant = this.getAttribute('data-variant') || 'standalone';
        if (variant !== 'section' && document.querySelector('.ew-vendor-feed--section')) return;
        var currentHandle = this.getAttribute('data-current-handle');
        var self = this;
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            if (currentHandle && window.CSS && CSS.escape) {
              doc
                .querySelectorAll('.swiper-slide[data-handle="' + CSS.escape(currentHandle) + '"]')
                .forEach(function (s) { s.remove(); });
            }
            var wrapper = doc.querySelector('.swiper-wrapper');
            var target = self.querySelector('.swiper-wrapper');
            if (wrapper && wrapper.querySelector('.swiper-slide') && target) {
              target.innerHTML = wrapper.innerHTML;
              self.initSlider();
            }
          })
          .catch(function (e) { console.error('[vendor-feed]', e); });
      }
    }

    customElements.define('vendor-feed-slider', VendorFeedSlider);
  }
  define();
})();